import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from "src/environments/environment"


@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this._authService.getAccessToken()).pipe(
      switchMap((access_token) =>
        from(this._authService.getIdToken()).pipe(
          switchMap((id_token) => {
            const authReq = request.clone({
              setHeaders: {
                accesstoken: access_token,
                idtoken: id_token,
              },
            });
            return next.handle(authReq);
          })
        )
      )
    );
  }
}
